import React, { useState, useEffect } from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import * as actions from "../../../store/actions";
import { getUserData } from "../../../utils/localStorage";
import "./index.css";
import S3 from "aws-s3";

// import QRCode from "qrcode.react";
import QRCode from "qrcode";
import Button from "../../../components/formElements/button/Button";
import branch from "branch-sdk";

const ShareProfile = ({
  updateDoctorQrCode,
  personalInfo,
  updateDoctorSignature,
}) => {
  let branchKey = process.env.REACT_APP_BRANCH_KEY;

  const userData = getUserData();

  async function downloadS3Image() {
    const url = userData?.qrcode_url
    // Extract the filename from the URL
    const filename = url.substring(url.lastIndexOf('/') + 1);

    try {
        // Fetch the image with cache disabled
        const response = await fetch(url, { cache: 'no-store' });

        // Convert the response to a blob
        const blob = await response.blob();

        // Create a temporary URL for the blob
        const blobUrl = window.URL.createObjectURL(blob);

        // Create an anchor element
        const anchor = document.createElement('a');
        anchor.style.display = 'none';
        anchor.href = blobUrl;
        anchor.setAttribute('download', filename);

        // Append the anchor to the document body
        document.body.appendChild(anchor);

        // Trigger a click event on the anchor
        anchor.click();

        // Remove the anchor from the document body
        document.body.removeChild(anchor);

        // Revoke the blob URL
        window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
        console.error('Error downloading image:', error);
    }
}

  useEffect(() => {
    console.log(!userData?.qrcode_url);
    if (!userData?.qrcode_url) {
      branch.init(branchKey, function (err, data) {
        console.log(err, data);
      });
      var linkData = {
        campaign: "content 123",
        channel: "website",
        feature: "dashboard",
        stage: "new user",
        tags: ["tag1", "tag2", "tag3"],
        alias: "",
        data: {
          custom_bool: true,
          custom_int: Date.now(),
          custom_string: userData?.id,
          any_value: userData?.id,
          $og_title: "Title",
          $og_description: "Description",
          $og_image_url: "http://lorempixel.com/400/400",
        },
      };
      branch.link(linkData, function (err, link) {
        QRCode.toDataURL(
          link,
          {
            width: 800,
            margin: 2,
            color: {
              // dark: '#335383FF',
              // light: '#EEEEEEFF'
            },
          },
          (err, link) => {
            if (err) return console.error(err);
            console.log(link);
            // setQr(link);
            updateDoctorQrCode(link);
          }
        );
      });
    }
  }, []);

  return (
    <div>
      <p className="DBSubTitle mb-4">Share Profile</p>
      <div className="shareProfileCard">
        <div className="qrCodeClass" id="qrcode">
          <img src={userData.qrcode_url} height="250px" id="image" />
        </div>
        <p className="DBSubTitle mb-4 textNameClass">
          {" "}
          {userData?.firstName + " " + userData?.lastName}
        </p>
        <div className="col-md-2 d-flex justify-content-between align-items-center mt-2 px-2 downloadButtonClass">
          <Button
            onClick={downloadS3Image}
            label="Download"
            className="btn-block"
          />
        </div>
      </div>
    </div>
  );
};

const mapStoreToProps = ({ onboarding }) => ({
  personalInfo: onboarding?.personalInfo,
});

const mapDispatchToProps = dispatch => ({
  updateDoctorQrCode: (downloadLink, cb) =>
    dispatch(actions.updateDoctorQrCode(downloadLink, cb)),
});

export default withRouter(
  connect(mapStoreToProps, mapDispatchToProps)(ShareProfile)
);
